/* Model */
class TimeWindowTypeDaysModel extends App.Models.BaseModel {
    modelUrl = 'TimeWindowTypeDays';

    fetchWithCriteria = (obj) => {
        return Monet.Model.fetchWithCriteria({
            options: obj,
            model: this
        });
    }
}

App.Models.TimeWindowTypeDays = TimeWindowTypeDaysModel;

/* Collection */
class TimeWindowTypeDaysCollection extends App.Collections.BaseCollection {
    url = 'TimeWindowTypeDays';
    model = App.Models.TimeWindowTypeDays;
}

App.Collections.TimeWindowTypeDayss = TimeWindowTypeDaysCollection;

/* Router */
class TimeWindowTypeDaysRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'TimeWindowTypeDays';
        const model = App.Models.TimeWindowTypeDays;
        const collectionClass = App.Collections.TimeWindowTypeDayss;

        super(entityName, model, collectionClass);
        
        if (!App.Forms.TimeWindowTypeDays) {
            App.Forms.TimeWindowTypeDays = {
                timeWindowTypeId: null
            };
        }

        App.Objects[this.entityName] = this;
    }

    getTimeWindowTypeDayId = () => {
        const windowHash = window.location.hash;
        let timeWindowTypeId = windowHash.replace('#/TimeWindowType/', '');
        timeWindowTypeId = timeWindowTypeId.substring(0, timeWindowTypeId.indexOf('/'));
        return timeWindowTypeId;
    }

    returnToList = () => {
        window.location = "#/TimeWindowType/" + this.getTimeWindowTypeDayId() + "/" + this.entityName;
    }


    afterCreate = () => {
        this.returnToList();
    }

    afterCreateForm = () => {
        const btnsCancel = document.querySelectorAll("#TimeWindowTypeDays  [name='btn_cancel']");
        btnsCancel.forEach(btnCancel => {
            btnCancel.removeEventListener('click', this.returnToList);
            btnCancel.addEventListener('click', this.returnToList);
        });

        const timeWindowTypeId = this.getTimeWindowTypeDayId();
        $(".MonetUIForm.TimeWindowTypeDays").append('<input type="hidden" id="timeWindowType_id" value="' + timeWindowTypeId + '" name="timeWindowType.id" class="modelAttribute" />');
        App.Forms.TimeWindowTypeDays.timeWindowTypeId = timeWindowTypeId;
        this.saveTimeWindowTypeId();
    }

    onValidate = () => {
        var validate = new Greenmile.TimeWindow.GeneralFunctions();
        this.allow_submit = validate.validateTimeWindow(this.allow_submit, 'TimeWindowTypeDays');
    }

    beforeList = () => {
        const timeWindowTypeId = this.getTimeWindowTypeDayId();
        App.Forms.TimeWindowTypeDays.timeWindowTypeId = timeWindowTypeId;
        const filterBuilder = App.Forms.TimeWindowTypeDays.filterBuilder;
        const defaultFilter = {
            'timeWindowType.id': {
                value: timeWindowTypeId
            }
        };

        filterBuilder.setSelectedFilters(defaultFilter);
        filterBuilder.setDefaultFilters(defaultFilter);
        $(".MonetUIForm.TimeWindowTypeDays [name='btn_novo']").on("click", function () {
            window.location = "#/TimeWindowType/" + timeWindowTypeId + "/TimeWindowTypeDays/new";
        });
    }

    beforeInitializeGrid = () => {
        // Update timeWindowType ID in storage filters
        const timeWindowTypeId = this.getTimeWindowTypeDayId();
        const sessionUserId = Monet.Session.User.id;
        const filters = JSON.parse(Monet.Session.sessionStorage.filters);
        filters[sessionUserId] = filters[sessionUserId] || {};
        filters[sessionUserId][this.entityName] = filters[sessionUserId][this.entityName] || {};
        filters[sessionUserId][this.entityName]["timeWindowType.id"] = {
            value: timeWindowTypeId
        };

        Monet.Session.sessionStorage.filters = JSON.stringify(filters);
    }

    saveTimeWindowTypeId = () => {
        const timeWindowTypeId = this.getTimeWindowTypeDayId();
        App.Forms.TimeWindowTypeDays.timeWindowTypeId = timeWindowTypeId;

        const form = App.Forms.TimeWindowTypeDays.form;

        const field = new Monet.UI.Fields.Base();
        field.getValue = function () {
            return { id: timeWindowTypeId };
        };
        field.render();
        form.setField('timeWindowType', field);
    }

    afterPopulateForm = () => {
        this.saveTimeWindowTypeId();
    }

    getData = (timeWindowDaysId, callback) => {
        const timeWindowTypeDay = new App.Models.TimeWindowTypeDays();
        timeWindowTypeDay.set({ id: timeWindowDaysId });
        timeWindowTypeDay.fetchWithCriteria({
            criteria: '{"filters":["*.**"]}',
            success: function (data) {
                const timeWindowTypeDay = new App.Models.TimeWindowTypeDays();
                timeWindowTypeDay.set(data);
                if (callback) {
                    callback(data);
                }
            }
        });
    }

    getFilter = () => {
        const timeWindowTypeId = App.Forms.TimeWindowType.form.fields.id.getValue();
        App.Forms.TimeWindowTypeDays.timeWindowTypeId = timeWindowTypeId;
        const filter = {
            timeWindowType: {
                id: timeWindowTypeId
            }
        };

        return JSON.stringify(filter);
    }
}

App.Routers.TimeWindowTypeDays = TimeWindowTypeDaysRouter;
